module.exports = __webpack_public_path__ + "static/media/proven-expert-seal.0f4ad923.png";